import { graphql } from 'gatsby';
import { Markup } from 'interweave';
import Cookies from 'js-cookie';
import React, { useEffect, useRef, useState } from 'react';

import ContentContainer from '../components/Common/ContentContainer';
import { PrimaryLink } from '../components/Common/Links';
import PageSection from '../components/Common/PageSection';
import ScrollTo, { smoothScrollToRef } from '../components/Common/ScrollTo';
import SmartLink from '../components/Common/SmartLink';
import Toast from '../components/Common/Toast';
import Layout from '../components/Layouts/Layout';
import MarketingSeo from '../components/MarketingSeo';
import fallbackHero from '../images/careers/WFH-fallback.png';
import * as styles from './jobPost.module.css';

const applyTracker = () => {
  const src = Cookies.get('gh_src');
  if (src) {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    if (!params.get('gh_src')) {
      params.append('gh_src', src);
      window.history.pushState({}, '', document.location.pathname + '?' + params.toString());
    }
  }
};

const JobPost = ({ data, pageContext, location }) => {
  const job = pageContext.job;
  const settings = data.settings;
  const hero = pageContext.hero || { description: 'Working from home', file: { url: fallbackHero } };
  useEffect(() => applyTracker);

  const scrollRef = useRef();
  const onApply = (e) => {
    e.preventDefault();
    smoothScrollToRef(scrollRef, 'smooth', 154);
  };

  return (
    <>
      <Layout>
        <MarketingSeo meta={{}} slug={location.pathname} />
        <ContentContainer slim isTopSection className={styles.topSection}>
          <div className={styles.headingCopy}>
            <div>
              <h1>{job.title}</h1>
              <p>{job.location}</p>
            </div>
            <div className={styles.tabletButton}>
              <PrimaryLink label={'Apply'} onClick={onApply} isButton />
            </div>
          </div>
          <div className={styles.headingImage}>
            <img alt={hero.description} src={hero.file.url} />
          </div>
          <div className={styles.mobileButton}>
            <PrimaryLink label={'Apply'} onClick={onApply} isButton />
          </div>
          <div className={styles.spacer} />
          <div className={styles.purple} />
        </ContentContainer>
        <PageSection slim className={styles.copyWrap} id={'job-description'}>
          <div className={styles.legal}>
            <SmartLink to="/careers/general-applicant-privacy-notice/">Candidate privacy information</SmartLink>
          </div>
          {/*<Markup tagName={'div'} className={styles.copy} content={content} />*/}
          <div dangerouslySetInnerHTML={{ __html: job.descriptionHtml }} className={styles.copy} />
          <div className={styles.applyButton}>
            <PrimaryLink isButton={true} label={'Submit Application'} url={`${job.jobUrl}/application`} />
          </div>
          <div id="ashby_embed" data-noChrome="true" data-jid={job.alternative_id} />
        </PageSection>
        <ScrollTo reference={scrollRef} />
        <PageSection slim className={styles.copyWrap}>
          <div className={styles.formWrap} />
        </PageSection>
      </Layout>
      {settings && settings.careersToastCtaLabel && settings.careersToastCtaUrl && (
        <Toast ctaLabel={settings.careersToastCtaLabel} ctaUrl={settings.careersToastCtaUrl} />
      )}
    </>
  );
};

export default JobPost;

export const query = graphql`
  query AshbyJobPostQuery($altId: String!) {
    settings: contentfulSiteSettings(id: { eq: "38fbb04c-d851-5f98-9200-1d9b8c32c012" }) {
      careersToastCtaLabel
      careersToastCtaUrl
    }
    page: ashbyAshbyjobs(jobs: { elemMatch: { alternative_id: { eq: $altId } } }) {
      jobs {
        address {
          addressRegion
          addressCountry
          addressLocality
        }
        alternative_id
        applyUrl
        department
        descriptionPlain
        descriptionHtml
        employmentType
        isListed
        isRemote
        jobUrl
        location
        publishedAt
        team
        title
      }
    }
  }
`;
